export const IFRAME_DATA_ID = 'Iframe-wrapper';
export const IFRAME_EDITOR_MODE_HEIGHT = '500px';
